<template>
  <div
    class="banner slide"
    :class="{'your-turn': isMyTurn }"
  >
    <template v-if="isMyTurn">
      Your Turn
    </template>
    <template v-else>
      {{ player.name }}'s turn
    </template>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import {NS_GAME_STATE} from "@/store/constants";

export default {
  name: "YourTurnBanner",

  data() {
    return {
      titleInterval: null,
    }
  },

  computed: {
    ...mapState(NS_GAME_STATE, [
      'soundFile',
    ]),

    ...mapGetters(NS_GAME_STATE, [
      'whosTurn',
      'localPlayer',
      'localPlayerId',
      'isMyTurn',
      'currentPlayer',
    ]),

    player() {
      return this.currentPlayer;
    }
  },

  watch: {
    isMyTurn (isMyTurn) {
      if (isMyTurn) {
        this.titleInterval = setInterval(function() {
          const yourTurnMessage = "Your TURN!!!";
          if (document.title === yourTurnMessage) {
            document.title = "Acquire";
            return;
          }
          document.title = yourTurnMessage;
        }, 1000);


        this.soundFile.sound.play()
          .then(ok => {
            console.log('Sound Played', ok);
          })
          .catch(error => {
            console.log('Sound Failed to play', error);
          })
      } else {
        if (this.titleInterval) {
          clearInterval(this.titleInterval);
        }
        document.title = "Acquire";
      }
    }
  },
}
</script>

<style scoped>
.banner {
  position: fixed;
  z-index: 5;
  top: 0;
  padding: 10px;
  box-sizing: border-box;
  width: 100%;
  font-weight: 600;
  background: #e4e4e4;
}

.your-turn {
  background: #154fb7;
  color: white;
  border-bottom: 1px solid white;
}

@media screen and (min-width: 587px) {
  .banner {
    position: relative;
    border-radius: 5px;
    margin-bottom: 5px;
  }
}

.slide {
  animation: slide-in 0.5s forwards;
  transform: translateX(-100%);
}

@keyframes slide-in {
  100% { transform: translateX(0%); }
}
</style>
